import type { ColorEffect } from "@color-finder/color-finder-api/models";
import { Chip, Stack } from "@mui/material";

const effectsMap: Record<ColorEffect, string> = {
  FLUORESCENT: "Fluorescent",
  MARBLE: "Marble",
  METALLIC_OR_PEARLESCENT: "Metallic / Pearlescent",
  PHOSPHORESCENT: "Phosphorescent",
};

export interface ColorEffectsProps {
  value: Array<ColorEffect>;
}

function ColorEffectsDisplay({ value }: ColorEffectsProps) {
  return (
    <Stack flexWrap="wrap" gap={1} direction="row">
      {value.map((effect) => (
        <Chip key={effect} size="small" label={effectsMap[effect]} />
      ))}
    </Stack>
  );
}

export default ColorEffectsDisplay;
